// extracted by mini-css-extract-plugin
export default {"HorizontalSeparator":"Separator_HorizontalSeparator__swqKT","VerticalSeparator":"Separator_VerticalSeparator__vLiya","DotSeparator":"Separator_DotSeparator__DQhpv"};